export default function validationSurface(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('SURFACE_SOLD_UNABLE_TO_INCREASE_RATIO') !== -1) {
      messages.push({
        message: 'addEditSurface.error.alreadySell',
      });
    }
  });
}
